
var BookingModel = function() {
    this.couponCode = '';
    this.couponPercent = 0;
    this.checkinDate = '';
    this.checkoutDate = '';
    this.rooms = 1;
    this.rewards = [];
};

BookingModel.prototype.getCouponCode = function() {
    return this.couponCode;
};

BookingModel.prototype.getCouponPercent = function() {
    return this.couponPercent;
};

BookingModel.prototype.getCheckinDate = function() {
    return this.checkinDate;
};

BookingModel.prototype.getCheckoutDate = function() {
    return this.checkoutDate;
};

BookingModel.prototype.getNumberOfNights = function() {
    return this.nights;
};

BookingModel.prototype.getRooms = function() {
    return this.rooms;
};

BookingModel.prototype.getRewards = function() {
    return this.rewards;
};

BookingModel.prototype.setCouponCode = function(couponCode) {
    this.couponCode = couponCode;
};

BookingModel.prototype.setCouponPercent = function(couponPercent) {
    this.couponPercent = couponPercent;
};

BookingModel.prototype.setCheckinDate = function(checkinDate) {
    this.checkinDate = checkinDate;
};

BookingModel.prototype.setCheckoutDate = function(checkoutDate) {
    this.checkoutDate = checkoutDate;
};

BookingModel.prototype.setPeriod = function(checkinDate, checkoutDate) {
    this.checkinDate = checkinDate;
    this.checkoutDate = checkoutDate;
    this.nights = checkoutDate.diff(checkinDate, 'days');
};

BookingModel.prototype.setNumberOfNights = function(nights) {
    this.nights = nights;
};

BookingModel.prototype.setRooms = function(rooms) {
    this.rooms = rooms;
};
    
BookingModel.prototype.setRewards = function(rewards) {
    this.rewards = rewards;
};

export default BookingModel;